"use client"
import { NftFiltersMoleculeReatom } from "@/app/nft/search/filters/store.reatom"
import { Trans } from "@lingui/react/macro"
import { Button } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"

export const ClearFilters = reatomComponent(() => {
  const { resetFilters, appliedFiltersCount } = useMolecule(
    NftFiltersMoleculeReatom,
  )
  const count = appliedFiltersCount()

  if (!count) return null

  return (
    <Button variant="outline" onClick={resetFilters} className="bg-transparent">
      <Trans>Reset</Trans>
    </Button>
  )
}, "ClearFilters")
